<!--
 * @Author: mazhigang
 * @Date: 2023-09-16 19:32:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-11-01 19:19:20
-->
<template>
  <div>
    <div class="bg">
      <div class="logo1">
        <img
          src="https://down.baoanlailou.com/00/comesLogo.png"
          alt=""
          style="width: 120px;height: 120px;"
        />
      </div>
      <div class="btnBox1">
        <div class="btnNew" @click="openUrl2()">
          <img src="https://down.baoanlailou.com/00/IOSDown.png" alt="" />
        </div>
        <div class="btnNew" @click="openUrl3()" style="margin-top: 20px;">
          <img src="https://down.baoanlailou.com/00/AndroidDown.png" alt="" />
        </div>
      </div>
    </div>
    <div v-if="model1 == true" class="model" @click="close">
      <div style="color: #fff;text-align: right;margin-right: 50px;">
        <div>
          <img
            src="https://down.baoanlailou.com/00/load.png"
            alt=""
            style="width: 77px;height: 60px;"
          />
        </div>
        <div
          style="display: flex;width: 100%;justify-content: end;padding-right: 35px;box-sizing: border-box;"
        >
          <div style="width: 200px;margin-right: 10px;font-size: 20px;">
            请点击右上角，使用默认浏览器打开App下载
          </div>
          <div>
            <img
              src="https://down.baoanlailou.com/00/serf1.png"
              alt=""
              style="width: 74px;height: 96px;"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="messageBox" v-if="model == true">
      下载链接已经为您复制，
      <div>请通过打开系统浏览器进行粘贴下载</div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      urlData: {},
      model: false,
      model1: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    isWeChatBrowser() {
      return /MicroMessenger/i.test(navigator.userAgent);
    },
    close() {
      this.model1 = false;
    },
    getList() {
      const url =
        process.env.NODE_ENV === "production"
          ? "https://manager-saas.baoanlailou.com/api/admin/app-version/latest"
          : "/manager-api/api/admin/app-version/latest";
      axios
        .get(url)
        .then(({ data }) => {
          this.urlData = data.data;
        })
        .catch()
        .finally();
    },
    openUrl2() {
      if (this.urlData.ios.url == "") {
        this.$message("正在建设中");
      } else {
        if (this.isWeChatBrowser()) {
          this.model1 = true;
        } else {
          window.location.href = this.urlData.ios.url;
        }
      }
    },
    openUrl3() {
      if (this.urlData.android.url == "") {
        this.$message("正在建设中");
      } else {
        if (this.isWeChatBrowser()) {
          this.model1 = true;
        } else {
          window.location.href = this.urlData.android.url;
        }
      }
    }
  }
};
</script>
<style scoped>
.messageBox {
  width: 80%;
  height: 150px;
  background: rgba(0, 0, 0, 0.68);
  border-radius: 22px;
  position: fixed;
  top: 35vh;
  left: 10%;
  text-align: center;
  padding: 50px 20px;
  box-sizing: border-box;
  color: #fff;
  font-size: 16px;
}
.model {
  width: 100%;
  height: 100%;
  background: rgb(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
}
.bg {
  width: 100%;
  height: 100vh;
  background-image: url("https://down.baoanlailou.com/00/comesBg.png");
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
}
.bg3 {
  width: 100%;
  height: 100vh;
  background-image: url("https://down.baoanlailou.com/00/user1.png");
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
}
.btnBox {
  /* margin-top: 580px; */
  text-align: center;
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  padding: 0 0 30px 0;
  box-sizing: border-box;
}
.btn {
  width: 309px;
  background: linear-gradient(180deg, #31afff 0%, #1677ff 100%);
  border-radius: 10px;
  border: 1px solid #979797;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
  padding: 10px 22px;
  box-sizing: border-box;
  margin: 30px auto 0;
}
.btn1 {
  width: 309px;
  background: linear-gradient(179deg, #00deb0 0%, #04b578 100%);
  border-radius: 10px;
  border: 1px solid #979797;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
  padding: 10px 22px;
  box-sizing: border-box;
  margin: 30px auto 0;
}
.bg1 {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
  background-image: url("https://down.baoanlailou.com/00/personBg.png");
}
.bg2 {
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  padding: 0 34px;
  box-sizing: border-box;
  overflow: hidden;
  background-image: url("https://down.baoanlailou.com/00/companyBg.png");
}
.logo {
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  top: 25vh;
}
.logo img {
  width: 190px;
  height: 190px;
}
.logo1 {
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  top: 47vh;
}
.logo1 img {
  width: 100px;
  height: 100px;
}
.btnNew {
  width: 100%;
  text-align: center;
  margin-top: 220px;
}
.btnNew img {
  width: 240px;
  height: 45px;
}
.btnBox1 {
  text-align: center;
  position: fixed;
  bottom: 9vh;
  left: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/posterComes/posterComes.vue